__webpack_require__.p = "/promocao/";